import { useState } from 'react';
import apiClient from '../services/apiClient';
import '../styles/LoginPage.css';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const GENERIC_LOGIN_ERROR = 'Login failed. Please check your credentials and try again.';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiClient.post('/api/auth/login', {
        username,
        password
      });

      onLogin(response.data);
    } catch (err) {
      setError(GENERIC_LOGIN_ERROR);
    } finally {
      setPassword('');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>RemediationJS</h1>
        <p className="subtitle">Remediation Score Reporting</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Your CyberTrek username"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your CyberTrek password"
              disabled={loading}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <p className="info-text">
          Enter your CyberTrek credentials to access remediation reports
        </p>
      </div>
    </div>
  );
}
